import React from 'react'
import { Add, InfoOutlined, ModeEditOutlineTwoTone } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { BaseTabs } from "components/Shared/BaseTabs";
import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import AppTableDateTime from "components/Shared/AppTableDateTime";

import { useLazyListTransshipmentQuery } from "store/services/transhipmentApi";

import { useAppMeta, useTablePagination } from "hooks";

import ExportTransshipmentExcel from "./TranshipmentController/ExportTransshipmentExcel";
const TransshipmentListScreen = () => {

  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [{ title: "Transhipment" }];

  const transhipmentTabs = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const columns = [
    {
      name: "Loading ID",
      selector: (row) => row?.loadingId,
      cell: (row) => row?.loadingId
    },
    {
      name: "Shipment ID",
      selector: (row) => row?.shipment?.shipmentId,
      cell: (row) => row?.shipment?.shipmentId,
    },
    {
      name: "Collection ID",
      selector: (row) => row?.fulfillment?.collectionId,
      cell: (row) => row?.fulfillment?.collectionId,
    },
    {
      name: "Loading Time",
      selector: (row) => <AppTableDateTime date={row?.loadingTime} />,
    },
    {
      name: "UnLoading Time",
      selector: (row) => <AppTableDateTime date={row?.unloadingTime} />,
    },
    {
      name: "Loading Location",
      selector: (row) => `lat: ${row?.loadingLocation?.lat}, 
      lon: ${row?.loadingLocation?.lon}`,
    },
    {
      name: "Unloading Location",
      selector: (row) => `lat: ${row?.unloadingLocation?.lat}, 
      lon: ${row?.unloadingLocation?.lon}`,
    },
    {
      name: "Cargo Type",
      selector: (row) => row?.cargoType,
      cell: (row) => row?.cargoType
    },
    {
      name: "Cargo Condition",
      selector: (row) => row?.cargoCondition,
      cell: (row) => row?.cargoCondition
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link
            to={`/app/crm/transshipment/${row?._id}/detail`}>
            <IconButton size="small" aria-label="View Transshipment" color="primary">
              <InfoOutlined />
            </IconButton>
          </Link>
          <Link
            to={`/app/crm/transshipment/${row?._id}/edit`}>
            <IconButton size="small" aria-label="Edit Transshipment">
              <ModeEditOutlineTwoTone />
            </IconButton>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      right: true,
    },

  ];
  // RTK Query
  const [fetchTransshipment, { data: transshipmentRes, isLoading, isFetching, error }] =
    useLazyListTransshipmentQuery();

  React.useEffect(() => {
    fetchTransshipment({
      active: activeTab === "Active",
      page: currentPage,
      limit: perPage,
      ...(keyword && { keyword })
    });
  }, [activeTab, currentPage, fetchTransshipment, keyword, perPage])

  useAppMeta(`${activeTab} Transshipment`);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <BaseTabs
          tabs={transhipmentTabs}
          defaultValue={activeTab}
          actions={<ExportTransshipmentExcel />}
        />

        <TableFilter
          searchLabel="Loading ID"
          disabled={isLoading || isFetching}
        >
          <div className="font-medium"> {activeTab} Transshipment </div>
        </TableFilter>

        <AppTable
          columns={columns}
          data={transshipmentRes?.data ?? []}
          progressPending={isLoading || isFetching}
          paginationPerPage={perPage}
          paginationTotalRows={transshipmentRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default TransshipmentListScreen;

const PageActions = () => {
  return (
    <>
      <Link to="/app/crm/transshipment/create">
        <Button startIcon={<Add />} variant="contained" color="primary">
          Add Transshipment
        </Button>
      </Link>
    </>
  );
}